import {
  IQuestionnaireRegistry,
  IQuestionnaireGlossaryRepository,
  IQuestionnaireVariableRepository,
} from "../../../domain/questionnaire";
import { QuestionnaireGlossaryRepository } from "./QuestionnaireGlossaryRepository";
import { QuestionnaireVariableRepository } from "./QuestionnaireVariableRepository";

export class QuestionnaireRegistry implements IQuestionnaireRegistry {
  constructor(private readonly _getToken: () => string) {}

  getGlossaryRepository(): IQuestionnaireGlossaryRepository {
    return new QuestionnaireGlossaryRepository(this._getToken);
  }

  getVariableRepository(): IQuestionnaireVariableRepository {
    return new QuestionnaireVariableRepository(this._getToken);
  }
}
